var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body_show container-fluid pt-4 pb-5 search"},[(_vm.isLoaded && !_vm.isEmpty(_vm.searchFilterObject))?_c('search-container',{attrs:{"isWithFixedFilter":_vm.searchFilterObject}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }